import 'react-image-lightbox/style.css'

import Box from '@material-ui/core/Box'
import {
  StoryblokComponent,
  useStoryblokEditable
} from '@sb-konzept/gatsby-source-storyblok'
import React, { useMemo, useState } from 'react'
import Lightbox from 'react-image-lightbox'

function split(arr, n) {
  const res = []

  if (n < 1 || n > arr.length) return [arr]

  const clone = [...arr]
  while (clone.length) {
    res.push(clone.splice(0, n))
  }
  return res
}

function NewsImageBlock(props) {
  const { content } = props
  const { images } = content
  const { editableProps } = useStoryblokEditable()

  const lightboxImages = useMemo(
    () => images.map((node) => node.image.localFile?.publicURL),
    [images]
  )
  const [isOpen, setIsOpen] = useState(false)
  const [lightboxIndex, setLighboxIndex] = useState(0)

  const allRows = useMemo(() => split(images, 1))
  const rows = allRows.slice(0, 1)

  return (
    <>
      <Box {...editableProps} minHeight={120}>
        {rows.map((row, rIdx) => {
          const rowAspectRatioSum = 1

          return row.map((image, idx) => (
            <StoryblokComponent
              key={image._uid || image.id}
              content={image}
              rowAspectRatioSum={rowAspectRatioSum}
              onClick={() => {
                setIsOpen(true)
                setLighboxIndex(idx + rIdx * row.length)
              }}
            />
          ))
        })}
      </Box>
      {isOpen && (
        <Lightbox
          mainSrc={images[lightboxIndex].image.localFile.publicURL}
          mainSrcThumbnail={
            images[lightboxIndex].image.localFile.childImageSharp.fluid.base64
          }
          nextSrc={
            images[(lightboxIndex + 1) % lightboxImages.length].image.localFile
              .publicURL
          }
          nextSrcThumbnail={
            images[(lightboxIndex + 1) % lightboxImages.length].image.localFile
              .childImageSharp.fluid.base64
          }
          prevSrc={
            images[
              (lightboxIndex + lightboxImages.length - 1) %
                lightboxImages.length
            ].image.localFile.publicURL
          }
          prevSrcThumbnail={
            images[
              (lightboxIndex + lightboxImages.length - 1) %
                lightboxImages.length
            ].image.localFile.childImageSharp.fluid.base64
          }
          reactModalStyle={{ overlay: { zIndex: 1200 } }}
          onCloseRequest={() => setIsOpen(false)}
          onMoveNextRequest={() =>
            setLighboxIndex((lightboxIndex + 1) % lightboxImages.length)
          }
          onMovePrevRequest={() =>
            setLighboxIndex(
              (lightboxIndex + lightboxImages.length - 1) %
                lightboxImages.length
            )
          }
        />
      )}
    </>
  )
}

export default NewsImageBlock
